export const getters = {
  purchaseitemsRows: state => state.purchase_order_items,
  systemPurchaseorders: state => state.purchaseorders,
  Purchaseorderitem: state => state.systemPurchaseorderItem
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchaseorders/getters.js